import React from "react";
import { DisabledPrompt, useRoute } from "bcms-react";
import CustomSelect, { CustomSelectItem } from "components/custom-ui/CustomSelect";
import { FormContainer, FormRowView, WidgetContainer, WidgetView } from "components/shared";
import { FormButtonRow, HorizontalFormRow } from "components/shared/containers/FormContainer";
import { PrimaryButton, SecondaryButton, UIPhoneNumberInput, UITextInput } from "components/ui";

import "./styles.css";

/**
 * @function AddressAndPhoneNumberWidget
 * @return {React.Component}
 * @exported true
 * @description The main widget used in the ACTContactInfoPage. 
 */
export default function AddressAndPhoneNumberWidget(props) {
  const navigate = useRoute();

  return (
    <WidgetContainer className="address-and-phone-number-widget">
      <WidgetView text="Address And Phone Number">
        <FormContainer className="address-phone-number-form">
          <FormRowView className="address-line-1-row-view" text="Address Line 1">
            <UITextInput />
          </FormRowView>
          <FormRowView className="address-line-2-row-view" text="Address Line 2 (Optional)">
            <UITextInput />
          </FormRowView>
          <HorizontalFormRow>
            <FormRowView className="city-row-view" text="City">
              <UITextInput />
            </FormRowView>
            <FormRowView className="state-row-view" text="State">
              <CustomSelect className="state-custom-select" value="1">
                <CustomSelectItem value="1" >-- Select a State --</CustomSelectItem>
                <CustomSelectItem>ALABAMA</CustomSelectItem>
                <CustomSelectItem>ALASKA</CustomSelectItem>
                <CustomSelectItem>ARIZONA</CustomSelectItem>
                <CustomSelectItem>ARKANSAS</CustomSelectItem>
                <CustomSelectItem>CALIFORNIA</CustomSelectItem>
                <CustomSelectItem>COLORADO</CustomSelectItem>
                <CustomSelectItem>CONNECTICUT</CustomSelectItem>
                <CustomSelectItem>DELAWARE</CustomSelectItem>
                <CustomSelectItem>FLORIDA</CustomSelectItem>
                <CustomSelectItem>GEORGIA</CustomSelectItem>
                <CustomSelectItem>HAWAII</CustomSelectItem>
                <CustomSelectItem>IDAHO</CustomSelectItem>
                <CustomSelectItem>ILLINOIS</CustomSelectItem>
                <CustomSelectItem>INDIANA</CustomSelectItem>
                <CustomSelectItem>IOWA</CustomSelectItem>
                <CustomSelectItem>KANSAS</CustomSelectItem>
                <CustomSelectItem>KENTUCKY</CustomSelectItem>
                <CustomSelectItem>LOUISIANA</CustomSelectItem>
                <CustomSelectItem>MAINE</CustomSelectItem>
                <CustomSelectItem>MARYLAND</CustomSelectItem>
                <CustomSelectItem>MASSACHUSETTS</CustomSelectItem>
                <CustomSelectItem>MICHIGAN</CustomSelectItem>
                <CustomSelectItem>MINNESOTA</CustomSelectItem>
                <CustomSelectItem>MISSISSIPPI</CustomSelectItem>
                <CustomSelectItem>MISSOURI</CustomSelectItem>
                <CustomSelectItem>MONTANA</CustomSelectItem>
                <CustomSelectItem>NEBRASKA</CustomSelectItem>
                <CustomSelectItem>NEVADA</CustomSelectItem>
                <CustomSelectItem>NEW HAMPSHIRE</CustomSelectItem>
                <CustomSelectItem>NEW JERSEY</CustomSelectItem>
                <CustomSelectItem>NEW MEXICO</CustomSelectItem>
                <CustomSelectItem>NEW YORK</CustomSelectItem>
                <CustomSelectItem>NORTH CAROLINA</CustomSelectItem>
                <CustomSelectItem>NORTH DAKOTA</CustomSelectItem>
                <CustomSelectItem>OHIO</CustomSelectItem>
                <CustomSelectItem>OKLAHOMA</CustomSelectItem>
                <CustomSelectItem>OREGON</CustomSelectItem>
                <CustomSelectItem>PENNSYLVANIA</CustomSelectItem>
                <CustomSelectItem>RHODE ISLAND</CustomSelectItem>
                <CustomSelectItem>SOUTH CAROLINA</CustomSelectItem>
                <CustomSelectItem>SOUTH DAKOTA</CustomSelectItem>
                <CustomSelectItem>TENNESSSEE</CustomSelectItem>
                <CustomSelectItem>TEXAS</CustomSelectItem>
                <CustomSelectItem>UTAH</CustomSelectItem>
                <CustomSelectItem>VERMONT</CustomSelectItem>
                <CustomSelectItem>VIRGINIA</CustomSelectItem>
                <CustomSelectItem>WASHINGTON</CustomSelectItem>
                <CustomSelectItem>WEST VIRGINIA</CustomSelectItem>
                <CustomSelectItem>WISCONSIN</CustomSelectItem>
                <CustomSelectItem>WYOMING</CustomSelectItem>
              </CustomSelect>
            </FormRowView>
            <FormRowView className="zip-row-view" text="Zip Code">
              <UITextInput />
            </FormRowView>
          </HorizontalFormRow>
          <FormRowView className="home-phone-row-view" text="Home Phone (Optional)">
            <UIPhoneNumberInput />
          </FormRowView>
          <FormRowView className="mobile-phone-row-view" text="Mobile Phone (Optional)">
            <UIPhoneNumberInput />
          </FormRowView>
          <FormRowView className="work-phone-row-view" text="Work Phone (Optional)">
            <UIPhoneNumberInput />
          </FormRowView>
          <FormButtonRow>
            <SecondaryButton text="Cancel" onClick={() => { navigate("/profile") }} />
            <DisabledPrompt>
              <PrimaryButton text="Update" />
            </DisabledPrompt>
          </FormButtonRow>
        </FormContainer>
      </WidgetView>
    </WidgetContainer>
  )
}
